import { render, staticRenderFns } from "./edit-task-priority.vue?vue&type=template&id=ce67baaa&"
import script from "./edit-task-priority.vue?vue&type=script&lang=js&"
export * from "./edit-task-priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce67baaa')) {
      api.createRecord('ce67baaa', component.options)
    } else {
      api.reload('ce67baaa', component.options)
    }
    module.hot.accept("./edit-task-priority.vue?vue&type=template&id=ce67baaa&", function () {
      api.rerender('ce67baaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/task/edit-task-priority.vue"
export default component.exports